<template>
  <div class="fullHeight">
    <MypageSideMenu :memberDropClose="true"/>
    <Card
        :page_title="page_title"
        iconclass="icon-icon-friend mypage-title-icon"
    >
      <!-- 以下内容 -->
      <!-- <div class="reseveTabletitle mb-3 font-weight-bold">{{ page_title }}</div> -->
        <table class="table table-striped mypage-friend-list">
            <thead class="sp_not">
                <tr>
                    <th scope="col">お名前</th>
                    <th class="min-width-35" scope="col">メールアドレス</th>
                    <th class="min-width-35" scope="col">携帯番号</th>
                    <th class="text-center" scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <template v-if="friendList.length === 0">
                    <tr>
                        <td colspan="4" class="text-center">データがありません</td>
                    </tr>
                </template>
                <template v-else>
                    <tr v-for="data in friendList" :key="data.id">
                        <td class="d-flex justify-content-between d-lg-table-cell">
                            <span class="sp_label">お名前</span>
                            <span @click="openEditModal(data)" class="link-url text-right">{{ data.family_name }}&nbsp;&nbsp;{{ data.given_name }}</span>
                        </td>
                        <td class="max-width-50 d-flex justify-content-between d-lg-table-cell text-break flex-column flex-sm-row">
                            <span class="sp_label">メールアドレス&nbsp;</span>
                            <span class="text-right">{{ data.email }}</span>
                        </td>
                        <td class="max-width-50 d-flex justify-content-between d-lg-table-cell text-break flex-column flex-sm-row">
                            <span class="sp_label">携帯番号&nbsp;</span>
                            <span class="text-right">{{ formatSP(data.mobile_number) }}</span>
                        </td>
                        <td class="btn-align d-flex justify-content-center d-lg-table-cell">
                            <button
                                class="bluebackbutton col-btn-size"
                                @click="deleteOverlayDisplay(data)"
                            >削&nbsp;&nbsp;除
                            </button>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <nav aria-label="Page navigation" class="w-100">
            <ul class="pagination pagination-sm">
                <li class="page-item" @click="ClickPagination('Previous')">
                    <span class="framebutton Mypagepoint_pagelinkwidth py-1">前へ</span>
                </li>
                <li class="pagination-center">
                    <span>{{ pagination }} / {{ maxPaginationNotReturnZero }}</span>
                </li>
                <li class="page-item" @click="ClickPagination('Next')">
                    <span class="framebutton Mypagepoint_pagelinkwidth py-1">次へ</span>
                </li>
            </ul>
        </nav>
        <div class="row row-notMx justify-content-center w-100 py-2">
            <div class="col-sm-4 w-100">
                <button
                    class="bluebackbutton w-100"
                    @click="openAddtModal"
                >お友達登録</button>
            </div>
        </div>
    </Card>
    <MypageMenuFooter/>
    <FriendInputModal
        v-if="inputModal === true"
        @close="closeEvent"
        :memberData="member"
        :editMode="editMode"
    />
    <ConfirmDialog
      v-if="deleteDialog === true"
      initialMessage="この友達を削除します。"
      doing="削除"
      notDoing="閉じる"
      :processing="processing"
      @from-Dialog="deleteGolfFriend"
      @closeBtn="deleteOverlayHidden" />
  </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import ConfirmDialog from '../components/ConfirmDialog';
import { CODE_MASTER } from '../../config.js';
import {
    GET_FRIEND_LIST,
    DELETE_GOLF_FRIEND } from '../../constants/golf_friend';
import FriendInputModal from '../components/FriendInputModal';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        Card,
        ConfirmDialog,
        FriendInputModal
    },
    data () {
        return {
            memberNo: '',
            page_title: 'お友達登録',
            inputModal: '',
            deleteDialog: '',
            // 削除用ID
            deleteId: '',
            // FriendInputModalに渡す値
            member: {
                familyName: '',
                givenName: '',
                email: '',
                mobileNumber: '',
                friendId: 0,
                friendMemberNo: 0
            },
            // FriendInputModalに渡す値
            editMode: false,
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            golf_group_code: process.env.MIX_GROUP_CODE,
            // 予約情報
            friendList: [],
            // 表示中の期間期限ポイントページネーション数
            pagination: 1,
            // 期間期限ポイント最大ページネーション数
            max_pagination: 0,
            // 一覧取得の開始値
            begin_row: 0,
            // 一覧の最大表示値
            limit_rows: 10
        };
    },
    created () {
        this.memberNo = this.$store.state.auth.loginMember.member_no;
        this.getFriendList();
    },
    computed: {
        maxPaginationNotReturnZero () {
            return this.max_pagination === 0 ? 1 : this.max_pagination;
        },
        disabledPagination () {
            return this.max_pagination === 0 || this.max_pagination === 1;
        }
    },
    methods: {
          /** ----------------------------------------------
         * ページネーション処理
         * ---------------------------------------------- */
        ClickPagination: function (mode) {
            // 前へボタン押下時処理
            if (mode === 'Previous') {
                if (this.pagination > 1) {
                    this.pagination--;
                    if (this.display_pagination === 1) {
                        this.begin_row = 0;
                    } else {
                        this.begin_row = this.begin_row - this.limit_rows;
                    }
                    this.getFriendList();
                } else {
                    return;
                }
            } else {
                // 次へボタン押下時処理
                if (this.pagination < this.max_pagination) {
                    this.begin_row = this.begin_row + this.limit_rows;
                    this.pagination++;
                    this.getFriendList();
                } else {
                    return;
                }
            }
        },
        /** ----------------------------------------------
         * キャンセルダイアログを表示
         * ---------------------------------------------- */
        deleteOverlayDisplay (data) {
          this.deleteId = data.id;
          this.deleteDialog = !this.deleteDialog;
        },
        /** ----------------------------------------------
         * キャンセルダイアログを表示
         * ---------------------------------------------- */
        deleteOverlayHidden (data) {
          this.deleteDialog = !this.deleteDialog;
          this.$set(this.processing, 'result', '');
        },
        /** ----------------------------------------------
         * 予約一覧を取得
         * ---------------------------------------------- */
        getFriendList () {
            this.$apollo.mutate({
                fetchPolicy: 'no-cache',
                mutation: GET_FRIEND_LIST,
                    variables: {
                        member_no: this.memberNo,
                        limit: this.limit_rows,
                        offset: this.begin_row
                    }
                }).then(res => {
                    const data = res.data.getGolfFriendList.GolfFriendList;
                    const totalCount = res.data.getGolfFriendList.totalCount;
                    this.max_pagination = Math.ceil(totalCount / this.limit_rows);
                    this.friendList.splice(0, this.friendList.length);
                    data.forEach(el => {
                        this.friendList.push(el);
                    });
                }).catch(error => {
                    this.$set(this.processing, 'resultText', error);
                })
        },
        /** ----------------------------------------------
         * キャンセル処理を表示
         * ---------------------------------------------- */
        deleteGolfFriend () {
            this.$set(this.processing, 'btnDisabled', 1);
            this.$apollo.mutate({
                mutation: DELETE_GOLF_FRIEND,
                variables: {
                    id: this.deleteId
                }
            }).then(res => {
                const result = res.data.deleteGolfFriend.result
                if(result === 1){
                    return true;
                }else if (result === 0) {
                    throw res.data.errorMessage;
                    throw new Error(res.errorMessage);
                }
            }).then(res =>{
                this.deleteDialog = false;
                this.$set(this.processing, 'result', '');
                this.getFriendList();
                this.$set(this.processing, 'btnDisabled', 0);
            }).catch(error => {
                this.$set(this.processing, 'resultText', error);
                this.$set(this.processing, 'btnDisabled', 0);
            });
        },
        openAddtModal () {
            this.editMode = false;
            this.inputModal = !this.inputModal;
        },
        openEditModal (data) {
            this.$set(this.member, 'familyName', data.family_name);
            this.$set(this.member, 'givenName', data.given_name);
            this.$set(this.member, 'email', data.email);
            this.$set(this.member, 'mobileNumber', data.mobile_number);
            this.$set(this.member, 'friendId', data.id);
            this.$set(this.member, 'friendMemberNo', data.friend_member_no);
            this.editMode = true;
            this.inputModal = !this.inputModal;
        },
        closeEvent () {
            this.$set(this.member, 'familyName', '');
            this.$set(this.member, 'givenName', '');
            this.$set(this.member, 'email', '');
            this.$set(this.member, 'mobileNumber', '');
            this.$set(this.member, 'friendId', 0);
            this.$set(this.member, 'friendMemberNo', 0);
            this.getFriendList();
            this.inputModal = !this.inputModal;
        },
        formatSP(number){
            if (number != null){
                if (number.length == 11) {
                    return number.substr(0,3) + "-" + number.substr(3,4) + "-" + number.substr(7,4);
                }
            }
            return number
        }
    }
}

</script>

<style scoped>
.link-url{
    text-decoration: underline;
    color: #007bff;
}
.link-url:link, .link-url:visited, .link-url:hover, .link-url:active {
  color: blue;
  cursor : pointer;
}
</style>
